import Localization from '~/client/src/shared/localization/LocalizationManager'
import { NonWorkTimeReason } from '~/client/src/shared/stores/ui/ProjectDate.store'

/**
 * The message names the kind of non-work time an interval meets, not where in
 * the interval it sits, so an endpoint fault and a middle one read the same.
 *
 * Read per call rather than captured at module scope: the translator's language
 * is only settled once the user's locale loads, and a captured string would keep
 * whichever tree happened to be active at import time.
 */
export function getNonWorkTimeMessage(reason: NonWorkTimeReason): string {
  const { nonWorkDayOrDays, nonWorkHours } = Localization.translator

  switch (reason) {
    case NonWorkTimeReason.EndpointDay:
    case NonWorkTimeReason.MiddleDay:
      return nonWorkDayOrDays
    case NonWorkTimeReason.EndpointHours:
    case NonWorkTimeReason.MiddleHours:
      return nonWorkHours
  }
}

/**
 * The distinct messages a set of reasons deserves. Several reasons share a
 * wording, so the set keeps a caller from saying the same thing twice.
 */
export function getNonWorkTimeMessages(reasons: NonWorkTimeReason[]): string[] {
  return Array.from(new Set(reasons.map(getNonWorkTimeMessage)))
}

/** Faults between an interval's ends, which an endpoint label cannot report. */
export const MIDDLE_NON_WORK_REASONS: readonly NonWorkTimeReason[] = [
  NonWorkTimeReason.MiddleDay,
  NonWorkTimeReason.MiddleHours,
]
